import { createSlice, SerializedError } from "@reduxjs/toolkit";
import { LoadingState } from "http/model";
import { getAllShowsData, getShowData } from "appredux/actions/showActions";
import { IHorses } from "appredux/model/horses";
import { Show } from "api/shows/types";

export interface IHorsesState {
  status: LoadingState;
  error: null | SerializedError;
  horses: IHorses;
  shows: Show[];
  showStatus: LoadingState;
  showError: null | SerializedError;
}

const HORSES_INITIAL_STATE: IHorsesState = {
  status: LoadingState.initial,
  error: null,
  horses: {},
  shows: [],
  showStatus: LoadingState.initial,
  showError: null,
};

const showsSlice = createSlice({
  name: "horses",
  initialState: HORSES_INITIAL_STATE,
  reducers: {},
  extraReducers: (builder) => {
    // getAppData
    builder.addCase(getShowData.pending, (state: IHorsesState) => {
      state.status = LoadingState.loading;
    });
    builder.addCase(getShowData.fulfilled, (state: IHorsesState, action) => {
      state.horses[action.payload.id] = action.payload.app;
      state.status = LoadingState.loaded;
    });
    builder.addCase(getShowData.rejected, (state: IHorsesState, action) => {
      state.status = LoadingState.failed;
      state.error = action.error;
    });

    builder.addCase(getAllShowsData.pending, (state: IHorsesState) => {
      state.showStatus = LoadingState.loading;
    });
    builder.addCase(getAllShowsData.fulfilled, (state: IHorsesState, action) => {
      state.showStatus = LoadingState.loaded;
      state.shows = action.payload;
    });
    builder.addCase(getAllShowsData.rejected, (state: IHorsesState, action) => {
      state.showStatus = LoadingState.failed;
      state.showError = action.error;
    });
  },
});

export default showsSlice.reducer;
